// Material-UI
import { Divider, Grid, Stack } from "@mui/material";

// Project import
import { useTranslation } from "utils/locales/utilityFunctions";
import TextFieldInput from "components/input/textField";
import { beautifyNumber } from "utils/numberModification";
import { ActivityThinningObject } from "types/stand";
import SmallIconButton from "components/buttons/smallIconButton";
import DeleteRounded from "@mui/icons-material/DeleteRounded";
import AutoCompleteFiltered from "components/input/autoCompleteFiltered";

interface SingleThinningLineProps {
  data: ActivityThinningObject;
  speciesOptions?: { id: string; status: string; label: string; color?: string; type?: string }[];
  withoutPercentage?: boolean;
  disabled?: boolean;
  handleChangeSpecies?: (speciesId: string, thinningId: string) => void;
  handleChangeThinninggPercentage: (
    percentage: number,
    standId: string,
    thinningId?: string
  ) => void;
  deleteThinning: (thinningId: string, standId: string) => void;
}

const SingleThinningLine = ({
  data,
  speciesOptions,
  withoutPercentage,
  disabled,
  handleChangeThinninggPercentage,
  handleChangeSpecies,
  deleteThinning,
}: SingleThinningLineProps) => {
  // --- Hooks ---  //
  const { translate } = useTranslation();

  // --- Functions --- //
  const handleChangePercentage = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newVal = parseInt(e.target.value);
    if (newVal < 1) {
      newVal = 1;
    } else if (newVal > 100) {
      newVal = 100;
    }
    handleChangeThinninggPercentage(newVal, data.standId, data.thinningId);
  };

  const spcOptions = speciesOptions ? speciesOptions : [{ id: data.speciesId, label: data.speciesName, status: "enabled", color: data.speciesColor }];

  // --- Render --- //
  return (
    <>
      <Grid item sm={6} xs={12}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <SmallIconButton
            tooltipText={translate("input-dialog-raw-wood-tab-information-remove-species-tooltip")}
            status="enabled"
            onClick={() => deleteThinning(data.thinningId, data.standId)}
            disabled={data.disabled || disabled}
            orientation="horizontal"
          >
            <DeleteRounded fontSize="small" color={"primary"} />
          </SmallIconButton>

          <Divider orientation="vertical" flexItem />

          <AutoCompleteFiltered
            options={spcOptions}
            value={spcOptions.find((opt) => opt.id === data.speciesId && data.speciesId !== "non") || undefined}
            changeHandler={(_, v) => handleChangeSpecies && handleChangeSpecies(v.id, data.thinningId)}
            disabled={!handleChangeSpecies || disabled}
            numberOfOptions={5}
            label={translate("species")}
            placeholder={translate("species-search")}
          />
          {/* <Selector
            title={translate("species")}
            value={data.speciesId}
            options={
              speciesOptions
                ? speciesOptions
                : [{ id: data.speciesId, label: data.speciesName, color: data.speciesColor }]
            }
            label={true}
            fullWidth={true}
            changeHandler={(e) =>
              handleChangeSpecies && handleChangeSpecies(e.target.value, data.thinningId)
            }
            legendA={true}
            disabled={!handleChangeSpecies || disabled}
          /> */}
        </Stack>
      </Grid>

      {!withoutPercentage && (
        <>
          <Grid item sm={3} xs={6}>
            <TextFieldInput
              title={translate("thinning-percentage")}
              value={data.thinningPercentage ? data.thinningPercentage.toString() : "0"}
              handleChange={handleChangePercentage}
              showLabel={true}
              fullWidth={true}
              multiline={false}
              rows={1}
              type="number"
              disabled={data.disabled || disabled}
              inputAdornment="%"
            />
          </Grid>

          <Grid item sm={3} xs={6}>
            <TextFieldInput
              title={translate("volume")}
              value={
                (data.volume && beautifyNumber((data.volume * data.thinningPercentage) / 100)) ||
                "0"
              }
              showLabel={true}
              fullWidth={true}
              multiline={false}
              rows={1}
              type="number"
              inputAdornment="m3"
              disabled={true}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default SingleThinningLine;
